import { parseMessage } from '@src/locales/intl';
import type { RootState } from '@src/store/reduxstore';
import { ContactAssignment } from '@src/types/contactAssignment';

export const contactAssignedSelector =
  (contactId: string) => (state: RootState) =>
    state.adminHome?.contactAssignment[contactId]?.assignedTo;

export const contactAssignedToSelector =
  (contactId: string) => (state: RootState) => {
    const { assignedTo = {} as ContactAssignment } =
      state.adminHome?.contactAssignment[contactId] ?? {};

    return assignedTo && assignedTo?.description?.length
      ? assignedTo?.description
      : parseMessage('ContactAssigment.assignedType.unassign');
  };

export const isAssignedContactSuccessfullySelector =
  (contactId: string) => (state: RootState) =>
    state.adminHome?.contactAssignment[contactId]?.loading === 'success';

export const isAssignedContactUnsuccessfullySelector =
  (contactId: string) => (state: RootState) =>
    state.adminHome?.contactAssignment[contactId]?.loading === 'failure';
